/////////////////////////////
// types for nuxt config of files
/////////////////////////////

export const configCode = () =>
    `
  export default defineNuxtConfig({
  dir: {
        pages: "./pages",         // Custom pages directory
        layouts: "./layouts",     // Custom layouts directory
    //  plugins:"./plugins",      // Custom plugins directory  
    //  assets: "./assets",       // Custom assets directory
    //  middleware: "./middleware", // Custom middleware directory
  },
      extends:[]
  });
  `;